import project from "./project";
import activity from "./activity";
import upgrade from "./upgrade";
import wetstamps from "./wetstamps";
import comments from "../projectOverview/comments";
import changeorder from "./changeorder";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    project,
    activity,
    upgrade,
    wetstamps,
    comments,
    changeorder
  }
};
